<template>
  <div id="exam">
    <BottomBar />
    <Empty
      v-if="!detail"
      :loading="detail === undefined"
      :icon="true"
      title="无数据"
      subtitle="找不到该课堂测试报告"
    />
    <div v-else class="detail">
      <!-- 有内容 -->
      <router-link tag="div" to="/exams" class="back">
        <i class="anyteachicon anyteach-arrow-left" />查看更多
      </router-link>
      <div class="cover">
        <img
          src="https://anyteach3.oss-cn-shenzhen.aliyuncs.com/assets/exam-bgd.png?x-oss-process=image/resize,h_400"
        />
      </div>
      <div class="exam">
        <div class="flex top">
          <div class="title">
            <h3>
              <StudentName v-bind="detail.student" hide-age />
              <span>的测试报告</span>
            </h3>
            <h5>
              {{ detail.schedule.title }}
              <span v-if="units">· {{ units }} 单元测试</span>
            </h5>
          </div>
          <div class="ratings">
            <span class="star">★</span>
            {{ average }}
          </div>
        </div>
        <Sect title="老师">
          <div class="teacher">
            <div class="img" :style="$bgd(detail.teacher.teacher_gravatar)" />
            <span>{{ detail.teacher.teacher_name }}</span>
          </div>
        </Sect>
        <Sect v-if="detail.unit_id.length" title="单元">
          <h5 v-for="unit in detail.unit_id" :key="unit.id">{{ unit.title }}</h5>
        </Sect>
        <Sect title="时间">
          <div class="flex">
            <span>{{ startTime }}</span>
            <router-link tag="a" :to="scheduleTimeUrl">
              <i class="anyteachicon anyteach-view" />
              <span>查看</span>
            </router-link>
          </div>
        </Sect>
        <Sect :title="'评星 ' + average">
          <Rate category="流利度" :rating="detail.fluency" />
          <Rate category="准确度" :rating="detail.accuracy" />
          <Rate category="语音" :rating="detail.pronunciation" />
          <Rate category="听力" :rating="detail.listening" />
          <Rate category="交流" :rating="detail.communication" />
        </Sect>
        <Sect
          title="评语"
          :content="detail.comments"
          :content2="detail.comments_zh"
          note="中文评语为系统翻译，请以英文为准"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Empty from "../public/Empty"
import BottomBar from "../public/footer"
import Rate from "./Rate"
import Sect from "./Sect"
import StudentName from "@/components/public/StudentName"

export default {
  name: "Exam",
  components: {
    Empty,
    BottomBar,
    Rate,
    Sect,
    StudentName
  },
  data() {
    return {
      detail: undefined,
    }
  },
  computed: {
    scheduleTimeUrl() {
      return `/schedule/view/${this.detail.schedule.id}?st_id=${this.detail.schedule_time.id}`
    },
    examId() {
      return this.$route.query.id || this.$route.params.id
    },
    title() {
      if (!this.detail) return
      return `${this.detail.student_name} ${this.detail.student_name_eng} 的测试报告`
    },
    startTime() {
      if (!this.detail) return
      return this.$moment(this.detail.schedule_time.start_time).format("YYYY年M月D日 dddd HH:mm")
    },
    units() {
      if (!this.detail.unit_id.length) return null
      const units = this.detail.unit_id.map(unit => unit.title.replace(/[^0-9]/gi, "")).sort()
      if (units.length > 1) {
        return `${units[0]}-${units[units.length - 1]}`
      } else {
        return `${units[0]}`
      }
    },
    average() {
      return (
        (this.detail.fluency +
          this.detail.accuracy +
          this.detail.pronunciation +
          this.detail.listening +
          this.detail.communication) /
        5
      ).toFixed(1)
    },
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      const data = await this.$api.exam.DETAIL(this.examId)
      if (!data || !data.length) {
        return (this.detail = null)
      }

      let detail = data[0]
      this.detail = detail

      this.detail = detail
    },
  },
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
#exam {
  padding-bottom: $bottom-bar;
  padding-bottom: $iphone-x-bottom-bar;
  .cover {
    background: #ffa501;
    height: 140px;
    width: 100%;
    display: flex;
    padding-top: 10px;
    justify-content: center;
    img {
      text-align: center;
      height: 155px;
      display: block;
      margin: 0 auto;
      position: absolute;
    }
  }
  .top {
    padding: 25px 5% 10px 5%;
    border-bottom: 1px solid #eee;
  }
  .title {
    h3 {
      font-weight: bold;
      display: flex;
      font-size: 1.2rem;
      span:last-child {
        margin-left: 5px;
      }
    }
    h5 {
      opacity: 0.6;
      font-size: 0.9rem;
      font-weight: normal;
    }
  }
  .teacher {
    display: flex;
    align-items: center;
    span {
      font-size: 0.9rem;
    }
    .img {
      margin-right: 5px;
      $size: 35px;
      width: $size;
      height: $size;
      border-radius: 100%;
    }
  }
  .back {
    position: absolute;
    left: 5%;
    top: 15px;
    color: $dark-blue;
    font-size: 0.85rem;
    @include avenir-demi();
    transition: all 0.1s;
    &:active {
      opacity: 0.4;
    }
    i {
      margin-right: 5px;
      font-weight: 400;
    }
  }
  .detail {
    margin-bottom: 15px;
  }
}
</style>
